import { RouteConfig } from 'vue-router';
import { Routes } from '@/router/Routes';
import { CrmModules } from '@/types/CrmModules';

const DealsList = () => import(/* webpackChunkName: "Deals" */ '../views/deals-list/DealsList.vue');
const DealDetails = () => import(/* webpackChunkName: "Deals" */ '../views/deal-details/DealDetails.vue');
const ChooseOffers = () => import(/* webpackChunkName: "Deals" */ '@/components/wizard/ChooseOffers.vue');
const Checklist = () => import(/* webpackChunkName: "Deals" */ '@/components/checklist/Checklist.vue');
const SubmitApplication = () => import(/* webpackChunkName: "Deals" */ '@/components/wizard/SubmitApplication.vue');
const HouseholdManager = () => import(/* webpackChunkName: "Deals" */ '@/modules/multiForm/shared/components/HouseholdManager.vue');
const CreditDetailsProcess = () => import(/* webpackChunkName: "Deals" */ '@/modules/multiForm/views/CreditDetailsProcess.vue');
const VerificationView = () => import(/* webpackChunkName: "Deals" */ '@/components/wizard/VerificationView.vue');
const ReportView = () => import(/* webpackChunkName: "Deals" */ '@/components/wizard/ReportView.vue');
const EditBorrowerWrapper = () => import(/* webpackChunkName: "Deals" */ '@/components/wizard/EditBorrowerWrapper.vue');
const RealEstatesFormWrapper = () => import(/* webpackChunkName: "Deals" */ '@/modules/multiForm/views/RealEstatesFormWrapper.vue');
const BuildTrustSection = () => import(/* webpackChunkName: "Deals" */ '@/components/wizard/BuildTrustSection.vue');
const SigningDocuments = () => import(/* webpackChunkName: "Deals" */ '@/components/wizard/SigningDocuments.vue');
const KanbanDealsList = () => import(/* webpackChunkName: "Deals" */ '@/modules/deals/views/deals-list/KanbanDealsList.vue');

const DealProcessRoutes: Array<RouteConfig> = [
  {
    path: Routes.DEALS.WIZARD.BUILD_TRUST_SECTION,
    name: Routes.DEALS.WIZARD.BUILD_TRUST_SECTION,
    component: BuildTrustSection,
  },

  {
    path: Routes.DEALS.WIZARD.CHOOSE_OFFERS,
    name: Routes.DEALS.WIZARD.CHOOSE_OFFERS,
    component: ChooseOffers,
  },

  // Checklist
  {
    path: Routes.DEALS.WIZARD.CHECKLIST,
    name: Routes.DEALS.WIZARD.CHECKLIST,
    component: Checklist,
  },

  // Multiform
  {
    path: Routes.DEALS.WIZARD.BORROWERS,
    name: Routes.DEALS.WIZARD.BORROWERS,
    component: HouseholdManager,
  },
  {
    path: `${Routes.DEALS.WIZARD.CLIENT_DATA}-:index`,
    name: Routes.DEALS.WIZARD.CLIENT_DATA,
    component: EditBorrowerWrapper,
  },
  {
    path: `${Routes.DEALS.WIZARD.CREDIT_DETAILS}-:index`,
    name: Routes.DEALS.WIZARD.CREDIT_DETAILS,
    component: CreditDetailsProcess,
  },
  {
    path: Routes.DEALS.WIZARD.REAL_ESTATES,
    name: Routes.DEALS.WIZARD.REAL_ESTATES,
    component: RealEstatesFormWrapper,
  },

  // SubmitApplication
  {
    path: `${Routes.DEALS.WIZARD.SUBMIT_APPLICATION}`,
    component: VerificationView,
  },
  {
    path: `${Routes.DEALS.WIZARD.SUBMIT_APPLICATION}-:index`,
    name: Routes.DEALS.WIZARD.SUBMIT_APPLICATION,
    component: SubmitApplication,
  },

  // SigningDocuments
  {
    path: `${Routes.DEALS.WIZARD.SIGNING_DOCUMENTS}`,
    name: Routes.DEALS.WIZARD.SIGNING_DOCUMENTS,
    component: SigningDocuments,
  },

  // Report
  {
    path: Routes.DEALS.WIZARD.REPORT,
    name: Routes.DEALS.WIZARD.REPORT,
    component: ReportView,
  },
];

const DealsRoutes: Array<RouteConfig> = [
  {
    path: '',
    name: Routes.DEALS.DEALS_LIST,
    component: DealsList,
  },
  {
    path: 'deals_kanban',
    name: Routes.DEALS.KANBAN_DEALS_LIST,
    meta: {
      module: CrmModules.DEAL_KANBAN,
    },
    component: KanbanDealsList,
  },
  {
    path: ':id',
    name: Routes.DEALS.DEAL_DETAILS,
    component: DealDetails,
    meta: {
      module: CrmModules.DEAL_DETAILS,
    },
    children: DealProcessRoutes,
  },
];

export default DealsRoutes;
export {
  DealProcessRoutes
};
